// removed by extract-text-webpack-plugin
module.exports = {"link":"pageOffLeftMenu-module_link_Gx7oW","icon":"pageOffLeftMenu-module_icon_UCnpE"};


//////////////////
// WEBPACK FOOTER
// ./client/components/pageOffCanvasLeft/pageOffLeftMenu.module.css
// module id = 274
// module chunks = 1 2 3